<template>
  <v-container fluid class="pa-0">
    <v-row align="start">
      <v-col v-bind:class="{'mt-md-n10': !noMarginTop && !stackedView}" class="pt-0 align-self-start d-flex align-start" cols="12" :md="stackedView ? 12 : (showFilters ? 4 : 2)" :order="stackedView ? 3 : 2">
        <v-card class="pb-2" elevation="0" outlined v-show="showFilters">
          <v-row class="mx-0 pt-2">
            <v-col cols="12" class="py-1">
              <v-card-title class="pa-0 header-font py-2" style="font-size: 22px;">{{ $t('general.filters') }}</v-card-title>
              <MediaModeForm v-show="showFilters" v-if="(currentUser.clientType === 'Media' || currentUser.clientType === 'Driblab') && !stackedView" :fields="mediaModeFields"
                :mediaMode="mediaMode" @mediaModeChange="mediaMode = $event"
                :mediaModeData="mediaModeData" @mediaModeDataChange="onMediaModeDataChange($event)"
                :mediaModeFlags="mediaModeFlags" @mediaModeFlagsChange="mediaModeFlags = $event" selectorMode></MediaModeForm>
            </v-col>
            <!--Seasons-->
            <v-col cols="12" md="8" class="py-1" id="player-seasons">
              <div
                class="mr-5 pt-0 mt-0 primary--text font-weight-bold body-1"
              >
                {{ $t('table.clientLeagues.seasons') }}
              </div>
              <v-autocomplete clearable :items="playerSeasonDataFiltered" v-model="seasonDataSelectedModel"
                multiple 
                hide-details 
                dense 
                item-value="compoundId" 
                item-text="compoundText"
                @change="onSelectChange()" ref="autoCompleteSeasonRef"
                >
                <template v-slot:selection="{item,index}">
                  <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 w-90 black--text" v-if="index <= 2">
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="20" class="mr-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                    <span class="font-weight-bold text-ellipsis">{{item.seasonName}}</span>
                    <span class="mx-1">@</span>
                    <span class="font-weight-medium">{{item.teamName}}</span>
                  </v-chip>
                  <span
                        v-if="index === 3"
                        class="primary--text body-2 subheader-font"
                      >(+{{ seasonDataSelectedModel.length - 3 }} {{ $t('finishingMap.more') }})</span>
                </template>
                <template v-slot:item="{item}">
                  <v-card-text
                    class="pa-0 primary--text body-2 font-weight-medium d-flex align-center">
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="20" class="mr-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                    <span class="d-flex flex-column">
                      {{item.seasonName}}
                      <span>{{item.teamName}}</span>
                    </span>
                  </v-card-text>
                </template>
              </v-autocomplete>
            </v-col>
            <!--Filter Games-->
            <v-col cols="12" md="4" class="py-1 pl-1">
              <v-card-title class="pa-0 mr-0 body-1 font-weight-bold primary--text flex-shrink-0">{{ $t("general.filter") }} {{ $t("searchbar.games") }}</v-card-title>
              <v-card-text class="pa-0 flex-shrink-1">
                <v-autocomplete clearable class="pa-0 body-2 mb-2" hide-details dense
                  v-model="groundModel"
                  :items="grounds"
                  item-text="name"
                  item-value="id"
                  @change="onSelectChange()"
                >
                  <template v-slot:selection="{item,index}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 w-80 d-flex justify-center black--text" v-if="index <= 0">
                      <span class="body-2 text-ellipsis">{{item.name}}</span>
                    </v-chip>
                  </template>
                  <template v-slot:item="{item}">
                    <span class="body-2">{{item.name}}</span>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <!--Games-->
            <v-col cols="12" class="py-1">
              <v-card-title class="pa-0 mr-4 body-1 font-weight-bold primary--text flex-shrink-0">{{ $t("searchbar.games") }}</v-card-title>
              <v-card-text class="pa-0 flex-shrink-1">
                <v-autocomplete clearable multiple menu-props="auto" hide-details dense class="pa-0 body-2 mb-2"
                  v-model="gamesModel"
                  :items="gamesFiltered"
                  item-text="name"
                  item-value="gameId"
                  @blur="updateShots()"
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @mousedown.prevent @click="toggleGames">
                      <v-list-item-content class="py-0">
                        <v-list-item-title class="body-2">{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </template>
                  <template v-slot:selection="{item,index}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 black--text" v-if="index <= 0">
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.homeTeamId}.png`" type="image/png" height="20" class="mr-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                      <span class="body-2 text-ellipsis">{{item.name}}</span>
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.awayTeamId}.png`" type="image/png" height="20" class="ml-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                    </v-chip>
                    <span v-if="index === 1" class="primary--text body-2 subheader-font">(+{{ gamesModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                  <template v-slot:item="{item}">
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.homeTeamId}.png`" type="image/png" height="20" class="mr-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                    <span class="body-2">{{item.name}}</span>
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.awayTeamId}.png`" type="image/png" height="20" class="ml-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-col>
          </v-row>
          <!--Display type-->
          <v-row class="mx-0 pt-2">
            <v-col cols="12" class="pt-0">
              <div class="mb-n2 primary--text font-weight-bold body-1">{{ $t('general.displayType') }}</div>
              <v-radio-group v-model="selectedTab" row mandatory hide-details class="pt-0 align-center"
                id="player-finishing-selector"
                v-if="playerSeasonData && playerSeasonData.length"
                @change="onTabChange($event)"
              >
                <!--Pitch-->
                <v-radio value="topView" color="secondary" class="align-center">
                  <template v-slot:label>
                    <span class="body-1 primary--text d-inline-flex align-center">{{ $t('playerDetail.placer') }}<v-icon small class="ms-1">border_horizontal</v-icon></span>
                  </template>
                </v-radio>
                <!--Goal-->
                <v-radio value="frontView" v-if="showGoalChart" color="secondary" class="align-center">
                  <template v-slot:label>
                    <span class="body-1 primary--text d-inline-flex align-center">{{ $t('general.goal') }}<v-icon small class="ms-1">airplay</v-icon></span>
                  </template>
                </v-radio>
                <!--Distribution-->
                <v-radio value="distribution" color="secondary" class="align-center">
                  <template v-slot:label>
                    <span class="body-1 primary--text d-inline-flex align-center">{{ $t('general.distribution') }}<v-icon small class="ms-1">line_weight</v-icon></span>
                  </template>
                </v-radio>
              </v-radio-group>
              <v-skeleton-loader type="text@3" class="mt-3" v-if="!playerSeasonData.length"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <v-col class="d-flex pb-3 pl-0 justify-center" cols="12" v-if="$vuetify.breakpoint.smAndDown">
              <v-btn color="primary" class="monospace-font px-4" small outlined rounded @click="showShotOptions = !showShotOptions">
                  {{ showShotOptions ? $t('game.detail.hideShotOptions') : $t('game.detail.showShotOptions')}} <v-icon right > {{ showShotOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
              </v-btn>
            </v-col>
            <v-col v-if="showShotOptions && selectedTab !== 'distribution'" cols="12" sm="12" class="pt-0 pb-2">
              <div v-if="hasPenalties" class="mt-1 mb-n2 primary--text font-weight-bold body-1">{{ $t('game.detail.penalties') }}</div>
              <div v-if="hasPenalties" class="d-flex flex-wrap">
                <v-checkbox
                  v-if="penalties.length"
                  v-model="showPenalties"
                  :label="$t('finishingMap.penalty')"
                  color="secondary"
                  hide-details
                  class="pa-0 me-5"
                  @change="updateShots()"
                >
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('finishingMap.penalty') }}</span>
                  </template>
                </v-checkbox>
                <v-checkbox
                  v-if="penaltiesShootout.length"
                  v-model="showShootoutPenalties"
                  :label="$t('finishingMap.penaltyShootout')"
                  color="secondary"
                  hide-details
                  class="pa-0 me-5"
                  @change="updateShots()"
                >
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('finishingMap.penaltyShootout') }}</span>
                  </template>
                </v-checkbox>
              </div>
              <div class="mt-3 mb-n2 primary--text font-weight-bold body-1">{{ $t('general.visualization') }}</div>
              <div class="d-flex flex-wrap" id="shooting-location">
                <v-checkbox
                  v-model="checkboxCircles"
                  :label="$t('finishingMap.circles')"
                  color="secondary"
                  value="circles"
                  hide-details
                  class="pa-0 me-5"
                  @change="updateShots"
                ><template v-slot:label><span class="body-1 primary--text">{{ $t('finishingMap.circles') }}</span></template></v-checkbox>
                <v-checkbox
                  v-model="checkboxCircles"
                  :label="$t('finishingMap.boxes')"
                  color="secondary"
                  value="boxes"
                  hide-details
                  class="pa-0"
                  @change="updateShots"
                ><template v-slot:label><span class="body-1 primary--text">{{ $t('finishingMap.boxes') }}</span></template></v-checkbox>
              </div>
              <div class="d-flex align-center mt-2" v-if="checkboxCircles.includes('boxes')">
                <span class="mr-2 v-label cursor-pointer mt-1 primary--text body-1" @click="showAllInfoInBoxes = !showAllInfoInBoxes; updateShots()"
                >{{ $t('finishingMap.onlyPercentage') }}</span>
                <v-switch
                  v-model="showAllInfoInBoxes"
                  ref="showAllInfoInBoxes"
                  hide-details
                  color="secondary"
                  class="ma-0 primary--text body-1"
                  @change="updateShots"
                >
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t('finishingMap.showAll') }}</span>
                  </template>
                </v-switch>
              </div>
              <div id="on-target-section" v-if="playerPosition !== 1" class="d-flex flex-wrap">
                <v-checkbox
                  v-model="xgOnTarget"
                  :label="$t('statsNaming.xGOnTarget')"
                  color="secondary"
                  :value="true"
                  hide-details
                  class="pa-0 me-5"
                  @change="updateShots"
                >
                  <template slot="label">
                    <span class="body-1 primary--text">{{ $t('statsNaming.xGOnTarget') }}</span>
                    <v-tooltip top color="lightSecondary lighten-4" max-width="300">
                      <template #activator="{ on }">
                        <v-icon v-on="on" class="ml-1 opacity-8" color="secondary" small>info</v-icon>
                      </template>
                      <span class="black--text body-1">{{ $t('statsNaming.description.xGOnTarget') }}</span>
                    </v-tooltip>
                  </template>
                </v-checkbox>
                <v-checkbox
                  v-model="finishingXGOT"
                  :label="$t('statsNaming.FinishingxGOT')"
                  color="secondary"
                  :value="true"
                  hide-details
                  class="pa-0"
                  @change="updateShots"
                >
                  <template slot="label">
                    <span class="body-1 primary--text">{{ $t('statsNaming.FinishingxGOT') }}</span>
                    <v-tooltip top color="lightSecondary lighten-4" max-width="300">
                      <template #activator="{ on }">
                        <v-icon v-on="on" class="ml-1 opacity-8" color="secondary" small>info</v-icon>
                      </template>
                      <span class="black--text body-1">{{ $t('statsNaming.description.FinishingxGOT') }}</span>
                    </v-tooltip>
                  </template>
                </v-checkbox>
              </div>
            </v-col>
            <v-col class="py-0" cols="12" sm="12" v-if="showShotOptions && selectedTab === 'distribution'">
              <div class="mt-3 primary--text font-weight-bold body-1">{{ $t('finishingMap.distributionFilters') }}</div>
              <v-radio-group row dense hide-details class="mt-0 py-2" v-model="insightSelected" @change="onInsightChange()">
                <v-radio value="xg" color="secondary">
                  <template v-slot:label="">
                    <span class="body-1 primary--text">
                      {{$t('statsNaming.xG')}}
                    </span>
                  </template>
                </v-radio>
                <v-radio value="typeShot" color="secondary">
                  <template v-slot:label="">
                    <span class="body-1 primary--text">
                      {{$t('finishingMap.typesOfShot')}}
                    </span>
                  </template>
                </v-radio>
                <v-radio value="shotStrategy" color="secondary">
                  <template v-slot:label="">
                    <span class="body-1 primary--text">
                      {{$t('finishingMap.shotStrategy')}}
                    </span>
                  </template>
                </v-radio>
                <v-radio value="area" color="secondary">
                  <template v-slot:label="">
                    <span class="body-1 primary--text">
                      {{$t('finishingMap.areas')}}
                    </span>
                  </template>
                </v-radio>
                <v-radio value="bodyPart" color="secondary">
                  <template v-slot:label="">
                    <span class="body-1 primary--text">
                      {{$t('finishingMap.bodyPart')}}
                    </span>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-row id="shot-filters" class="mx-0">
              <v-col class="py-2" cols="12" sm="12" v-if="showShotOptions && selectedTab != 'frontView'">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.areas') }}</p>
                <v-btn small @click="onSelectAreaClick()" rounded class="elevation-0 monospace-font white--text px-2 my-1" color="secondary">
                  <v-icon color="white" x-small>filter_list</v-icon>
                  <span class="ms-1">{{ `${$t('areaSelector.filterAreas')} (${areaModel.length}/${currentUserAreas.length})`  }}</span>
                </v-btn>
              </v-col>
              <v-col class="py-0" cols="12" sm="12" v-if="showShotOptions && selectedTab === 'frontView'">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.areas') }}</p>
                <v-btn small @click="onSelectGoalAreaClick()" rounded class="elevation-0 monospace-font white--text px-2 my-1" color="secondary">
                  <v-icon color="white" x-small>filter_list</v-icon>
                  <span class="ms-1">{{ `${$t('areaSelector.filterAreas')} (${goalAreaModel.length}/14)`  }}</span>
                </v-btn>
              </v-col>
              <v-col class="py-2" cols="12" sm="12" v-if="showShotOptions">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.typesOfShot') }}</p>
                <v-autocomplete clearable hide-details dense
                  :items="shotTypesFiltered"
                  v-model="shotTypeModel"
                  item-text="text"
                  item-value="id"
                  class="pa-0"
                  multiple
                  @input="updateShots();"
                >
                  <v-list-item
                    slot="prepend-item"
                    ripple
                    @click="toggleShotTypes"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider
                    slot="prepend-item"
                    class="mt-2"
                  ></v-divider>
                  <template
                    slot="selection"
                    slot-scope="{ item, index }"
                  >
                    <v-chip v-if="index === 0" small color="lightSecondary lighten-2">
                      <span class="black--text">&nbsp;{{ item.text }}</span>
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="primary--text body-2 subheader-font"
                    >(+{{ shotTypeModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                  <template v-slot:item="{item}">
                    <span class="body-2 primary--text">{{item.text}}</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col class="py-2" cols="12" sm="12" v-if="showShotOptions">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.shotStrategy') }}</p>
                <v-autocomplete clearable hide-details dense
                  :items="shotStrategies"
                  v-model="shotStrategyModel"
                  item-text="text"
                  item-value="id"
                  class="pa-0"
                  multiple
                  @input="onStrategyInput();"
                >
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleShotStrategies"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                ></v-divider>
                  <template
                    slot="selection"
                    slot-scope="{ item, index }"
                  >
                    <template v-if="!item.isGroupHeader">
                      <v-chip v-if="index === 0" small color="lightSecondary lighten-2">
                        <span class="black--text">&nbsp;{{ item.text }}</span>
                      </v-chip>
                      <span
                        v-else-if="index === 1"
                        class="primary--text body-2 subheader-font"
                      >(+{{ shotStrategyModel.filter(id => id !== 'group_open' && id !== 'group_set').length - 1 }} {{ $t('finishingMap.more') }})</span>
                    </template>
                  </template>
                  <template v-slot:item="{item}">
                    <div v-if="item.isGroupHeader" class="d-flex align-center" style="width:100%">
                      <v-icon small class="mr-2" color="secondary">{{ isStrategyGroupSelected(item.id) ? 'check_box' : 'check_box_outline_blank' }}</v-icon>
                      <span class="body-2 primary--text font-weight-bold">{{ item.text }}</span>
                    </div>
                    <span v-else class="body-2 primary--text">{{item.text}}</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col class="py-2" cols="12" sm="12" v-if="showShotOptions">
                <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('finishingMap.bodyPart') }}</p>
                <v-autocomplete clearable dense
                  :items="bodyParts"
                  v-model="bodyPartModel"
                  item-text="text"
                  item-value="id"
                  class="pa-0"
                  multiple
                  @input="updateShots();"
                  hide-details
                >
                  <v-list-item
                    slot="prepend-item"
                    ripple
                    @click="toggleBodyPart"
                  >
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                  </v-list-item-content>
                  </v-list-item>
                  <v-divider
                    slot="prepend-item"
                    class="mt-2"
                  ></v-divider>
                    <template
                      slot="selection"
                      slot-scope="{ item, index }"
                    >
                    <v-chip v-if="index === 0" small color="lightSecondary lighten-2">
                      <span class="black--text">&nbsp;{{ item.text }}</span>
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="primary--text body-2 subheader-font"
                    >(+{{ bodyPartModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                  <template v-slot:item="{item}">
                    <span class="body-2 primary--text">{{item.text}}</span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row id="filters">
              <v-col class="d-flex py-1" cols="12" sm="12" v-if="showShotOptions">
                <v-range-slider
                  :label="$t('finishingMap.minutes')"
                  thumb-label
                  v-model="minutes"
                  :min="rangeMinutes[0]"
                  :max="rangeMinutes[1]"
                  step="1"
                  hide-details
                  :color="`secondary ${$vuetify.theme.dark ? 'lighten-3' : ''}`"
                  class="align-center px-3 py-0"
                  @input="updateShots"
                >
                  <template v-slot:label>
                    <div class="d-flex flex-column">
                      <span class="primary--text font-weight-bold body-1">{{ $t('finishingMap.minutes') }}</span>
                      <span class="body-2 subheader-font monospace-font">{{ `(${rangeMinutes[0]} - ${rangeMinutes[1]})` }}</span>
                    </div>
                  </template>
                </v-range-slider>
              </v-col>
            </v-row>
          </v-row>
          <!--Download actions-->
          <div v-if="!stackedView" class="pb-2 px-1 mt-5">
            <v-divider></v-divider>
          </div>
          <div v-if="!stackedView" class="d-flex justify-end py-0 w-100 pr-1" id="image-download">
            <v-btn color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small :x-small="!$vuetify.breakpoint.xsOnly" v-on:click.native="saveAsPNG()">
              <v-icon small class="mr-1">file_download</v-icon>
              <span class="">PNG</span>
            </v-btn>
            <v-btn color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small :x-small="!$vuetify.breakpoint.xsOnly" v-on:click.native="saveAsSVG()">
              <v-icon small class="mr-1">file_download</v-icon>
              <span>SVG</span>
            </v-btn>
            <v-btn color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small :x-small="!$vuetify.breakpoint.xsOnly" :loading="loadingExport" v-on:click.native="onGenerateIFrameClick()">
              <v-icon small class="mr-1">share</v-icon>
              <span>Embed</span>
            </v-btn>
          </div>
        </v-card>
        <div class="flex-shrink-0 ml-2 align-self-start">
          <slot name="filters-toggle"></slot>
        </div>
      </v-col>
      <v-col cols="12" sm="12" :md="stackedView ? 12 : (showFilters ? 8 : 10)" id="chart" ref="chart"
        class="text-center pa-0 align-self-start" :order="stackedView ? 1 : 2" v-bind:class="{'py-0':stackedView}">
        <PlayerAvatarMedia v-if="avatarSize && mediaMode" :width="selectedTab === 'topView' ? size : size * 1.25" :height="selectedTab === 'topView' ? avatarSize.height : avatarSize.height * 1.25 " :id="`${player.playerId}-${this.chartId}`"
          :margin="margin" :title="mediaModeData.upperText" :subtitle="mediaModeData.lowerText"
          :color="mediaModeData.borderColor" ref="playerAvatarMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
          :player="headerPlayer"
          :face="mediaModeData.face ? mediaModeData.face.dataUrl : null"
          :nationalTeam="mediaModeData.nationalTeam"
          type="finishingMap" :orientation="mediaModeData.orientation ? mediaModeData.orientation : 'left'"
          class="" :lineDistance="mediaModeData.lineLength" :avatarSize="mediaModeData.avatarSize" :lineWeight="mediaModeData.lineWeight"
          :upperTextFontSize="mediaModeData.upperTextFontSize" :upperTextFontWeight="mediaModeData.upperTextFontWeight"
          :lowerTextFontSize="mediaModeData.lowerTextFontSize" :lowerTextFontWeight="mediaModeData.lowerTextFontWeight"
          :fontFamily="mediaModeData.fontFamily"
          ></PlayerAvatarMedia>
        <XGChart
          v-if="size !== 0 && selectedTab === 'topView'"
          :size="size"
          :shots="filteredShots"
          :circlesAndBoxes="checkboxCircles"
          :xGOnTarget="xgOnTarget"
          :finishingXGOT="finishingXGOT"
          :key="xgMap"
          :playerPosition="playerPosition"
          :playerSeasonData="filteredSeasons"
          :playerName="player.name"
          :language="currentUserLanguage"
          :homeFillColor="mediaModeData.homeFillColor"
          :homeBorderColor="mediaModeData.homeBorderColor"
          :awayFillColor="mediaModeData.awayFillColor"
          :awayBorderColor="mediaModeData.awayBorderColor"
          :mediaMode="mediaMode"
          :fontFamily="mediaModeData.fontFamily"
          :id="`${player.playerId}-${this.chartId}`"
          :gameId="gameId"
          :gameIds="gameIds.length ? gameIds : gamesModel"
          :gameName="gameName"
          :minsPlayed="minsPlayed"
          ref="xgChart"
          @sizeChange="onChartSizeChange($event)"
          @loaded="onLoaded($event)"
          :showPenalties="showPenalties || showShootoutPenalties"
          :showAllInfoInBoxes="showAllInfoInBoxes"
          :teamId="teamId || 0"
          :filterShotTypeText="filterShotTypeText"
          :filterShotStrategyText="filterShotStrategyText"
          :filterBodyPartText="filterBodyPartText"
          :filterMinutesText="filterMinutesText"
        />
        <XGGoalChart
          v-if="size !== 0 && selectedTab === 'frontView'"
          :size="size * 1.25"
          :shots="filteredShots"
          :circlesAndBoxes="checkboxCircles"
          :xGOnTarget="xgOnTarget"
          :finishingXGOT="finishingXGOT"
          :key="xgMap"
          :playerPosition="playerPosition"
          :playerSeasonData="filteredSeasons"
          :playerName="player.name"
          :language="currentUserLanguage"
          :homeFillColor="mediaModeData.homeFillColor"
          :homeBorderColor="mediaModeData.homeBorderColor"
          :awayFillColor="mediaModeData.awayFillColor"
          :awayBorderColor="mediaModeData.awayBorderColor"
          :mediaMode="mediaMode"
          :fontFamily="mediaModeData.fontFamily"
          :id="`${player.playerId}-${this.chartId}`"
          :gameId="gameId"
          :gameIds="gameIds.length ? gameIds : gamesModel"
          :gameName="gameName"
          :minsPlayed="minsPlayed"
          :teamId="teamId || 0"
          :filterShotTypeText="filterShotTypeText"
          :filterShotStrategyText="filterShotStrategyText"
          :filterBodyPartText="filterBodyPartText"
          :filterMinutesText="filterMinutesText"
          ref="xgChart"
          @sizeChange="onChartSizeChange($event)"
          @loaded="onLoaded($event)"
          :showPenalties="showPenalties || showShootoutPenalties"
        />
        <FinishingTable v-if="selectedTab === 'distribution'" :id="`${player.playerId}-${this.chartId}`"
          :shots="filteredShots"
          :playerSeasonData="filteredSeasons"
          :size="size * 1.25"
          :type="insightSelected"
          :key="xgMap"
        ></FinishingTable>
        <DriblabSocialMedia v-if="player && avatarSize && size && mediaMode && mediaModeData.socialMedia"  :player="player"
          :width="selectedTab === 'topView' ? size : size * 1.25" :height="50" :id="`${player.playerId}-${this.chartId}`"
          :margin="margin" ref="driblabSocialMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
          :fontSize="mediaModeData.socialMediaFontSize" :fontWeight="mediaModeData.socialMediaFontWeight"
          :logoCfg="mediaModeData.logo" type="finishingMap" :sponsor="mediaModeData.sponsor.dataUrl" :fontFamily="mediaModeData.fontFamily"></DriblabSocialMedia>
      </v-col>
    </v-row>
    <!--Area Selector-->
    <AreaSelectorModal 
      ref="areaSelectorModalRef" 
      :title="`${$t('playerDetail.finishingMap')} - ${$t('areaSelector.selectAreas')}`"
      :areaModel="areaModel"
      :isVertical="true"
      @onConfirmClick="onAreaSelectorConfirm($event)"
    ></AreaSelectorModal>
    <!--Goal Area Selector-->
    <AreaSelectorModal 
      ref="goalAreaSelectorModalRef" 
      :title="`${$t('playerDetail.finishingMap')} - ${$t('areaSelector.selectAreas')}`"
      :areaModel="goalAreaModel"
      :isGoal="true"
      @onConfirmClick="onGoalAreaSelectorConfirm($event)"
    ></AreaSelectorModal>
    <ChartExportLinksModal ref="chartExportLinksModalRef" :title="player.name"
    :subtitle="$t('playerDetail.finishingMap')"></ChartExportLinksModal>
    <Tour v-if="currentUser.showTour && playerSeasonData && playerSeasonData.length" name="playerFinishingTour" :steps="tourSteps" />
  </v-container>
</template>

<script>
import * as d3 from "d3";
import * as _ from "lodash";

import Dictionary from '../../dictionary';
import GameService from '../../services/game/game.service';
import PlayerService from '../../services/player/player.service';
import UserService from '../../services/user.service';
import XGChart from '../base/XGChart';
import XGGoalChart from '../base/XGGoalChart';
import MediaModeForm from '../base/MediaModeForm';
import { exportSvg,downloadPng,copyAndAppendElement,loadFonts } from '../../utils/exportToPNG'
import PlayerAvatarMedia from './PlayerAvatarMedia'
import DriblabSocialMedia from '../base/DriblabSocialMedia'
import { userHasRole, getLeagueAndYearName, coordToArea } from '../../utils/functions';
import UserChartService from '../../services/user-chart.service';
import ChartExportLinksModal from '../base/ChartExportLinksModal';
import DocumentService from '../../services/document.service';
import FinishingTable from '../base/FinishingTable'
import Tour from "../base/Tour";
import { v4 } from 'uuid';
import * as moment from 'moment';
import * as html2canvas from 'html2canvas';
import AreaSelectorModal from "../modals/AreaSelectorModal.vue";

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8081';

const API_URL = NODE_ENV === 'production' ? 'https://pro.driblab.com/embed-chart/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/embed-chart/'

export default {
  name: 'FinishingMap',
  components: {
    XGChart,
    XGGoalChart,
    MediaModeForm,
    PlayerAvatarMedia,
    DriblabSocialMedia,
    ChartExportLinksModal,
    FinishingTable,
    Tour,
    AreaSelectorModal
  },
  props:{
    playerId:{
      type: Number,
      required: false
    },
    stackedView:{
      type: Boolean,
      required: false
    },
    chartId:{
      type: Number,
      default: 0
    },
    mediaModeCfg:{
      type: Object,
      required: false
    },
    mediaModeValue:{
      type: Boolean,
      required: false
    },
    headerPlayer:{
      type: Object,
      required: false
    },
    headerPlayerSeasonData:{
      type: Array,
      required: false
    },
    gamesPlayed:{
      type: Array,
      required: false
    },
    gameId:{
      type:Number,
      default: 0
    },
    gameName:{
      type: String,
      default: ""
    },
    defaultTab:{
      type: String,
      default: "topView"
    },
    language: {
      type: String,
      required: false
    },
    gameIds: {
      type: Array,
      required: false,
      default: () => []
    },
    showFilters: {
      type: Boolean,
      default: true
    },
    noMarginTop: { type: Boolean, default: false }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserLanguage() {
      return this.language ? this.language : this.$store.getters["auth/language"];
    },
    currentUserAreas(){
      let layoutId = this.$store.getters["auth/fieldLayout"]
      return _.chain(this.layouts).find(l => l.id === layoutId).get("areas").reduce((allAreas,a) => {
        allAreas.push(a);
        return allAreas;
      },[]).value();
    },
    layouts(){
      return this.$store.getters["general/fieldLayouts"];
    },
    shotTypesFiltered(){
       // Do not show shots on post and shots missed options in menus for GKs.
      if (this.playerPosition === 1) {
        this.shotTypeModel = [15, 16];
        return [
          {id: 16, text: Dictionary[this.$i18n.locale]["finishingMap"]["goal"]},
          {id: 15, text: Dictionary[this.$i18n.locale]["finishingMap"]["savedShot"]},
        ];
      }else{
        this.shotTypeModel = [13, 14, 15, 16, 60];
        return this.shotTypes;
      }
    },
    allShotTypes () {
      return this.shotTypeModel.length === this.shotTypesFiltered.length
    },
    allShotStrategies () {
      return this.shotStrategyModel.length === this.shotStrategies.filter(s => !s.isGroupHeader).length
    },
    allBodyParts () {
      return this.bodyPartModel.length === this.bodyParts.length
    },
    filterShotTypeText () {
      if (this.allShotTypes) return this.$t('general.all');
      const selected = this.shotTypesFiltered.filter(s => this.shotTypeModel.includes(s.id));
      if (!selected.length) return '—';
      if (selected.length === 1) return selected[0].text;
      if (selected.length === 2) return selected[0].text + ', ' + selected[1].text + '...';
      return selected[0].text + ` +${selected.length - 1}`;
    },
    filterShotStrategyText () {
      if (this.allShotStrategies) return this.$t('general.all');
      const selected = this.shotStrategies.filter(s => !s.isGroupHeader && this.shotStrategyModel.includes(s.id));
      if (!selected.length) return '—';
      const selectedIds = selected.map(s => s.id);
      const allOpenPlay = this.openPlayIds.every(id => selectedIds.includes(id));
      const anySetPiece = this.setPieceIds.some(id => selectedIds.includes(id));
      const allSetPiece = this.setPieceIds.every(id => selectedIds.includes(id));
      const anyOpenPlay = this.openPlayIds.some(id => selectedIds.includes(id));
      if (allOpenPlay && !anySetPiece) return Dictionary[this.$i18n.locale]["finishingMap"]["openPlay"];
      if (allSetPiece && !anyOpenPlay) return Dictionary[this.$i18n.locale]["finishingMap"]["setPiece"];
      if (allOpenPlay && allSetPiece) return this.$t('general.all');
      if (selected.length === 1) return selected[0].text;
      if (selected.length === 2) return selected[0].text + ', ' + selected[1].text + '...';
      return selected[0].text + ` +${selected.length - 1}`;
    },
    filterBodyPartText () {
      if (this.allBodyParts) return this.$t('general.all');
      const selected = this.bodyParts.filter(b => this.bodyPartModel.includes(b.id));
      if (!selected.length) return '—';
      if (selected.length === 1) return selected[0].text;
      if (selected.length === 2) return selected[0].text + ', ' + selected[1].text + '...';
      return selected[0].text + ` +${selected.length - 1}`;
    },
    filterMinutesText () {
      if (this.minutes[0] === this.rangeMinutes[0] && this.minutes[1] === this.rangeMinutes[1]) return '';
      return `${this.$t('table.roster.minutes')}: ${this.minutes[0]}' - ${this.minutes[1]}'`;
    },
    teamId(){
      if(this.seasonDataSelectedModel && this.seasonDataSelectedModel.length){
        const found = _.find(this.playerSeasonData,(sd) => sd.compoundId === this.seasonDataSelectedModel[0]);
        return found ? found.teamId : undefined;
      }
    },
    playerSeasonDataFiltered(){
      if(this.selectedTab === 'frontView'){
        return this.playerSeasonData.filter(s => [2,3].includes(s.providerId));
      }
      return this.playerSeasonData;
    },
    showGoalChart(){
      //Just show for Opta(2) or WyScout(3) providers
      return this.gameId > 0 || _.some(this.playerSeasonData,(s) => [2,3].includes(s.providerId));
    },
    darkMode(){
      return this.currentUser.darkMode || this.$vuetify.theme.dark
    },
    lastSearchId() {
      return this.$store.state.auth.lastSearch;
    },
    allGames () {
      return this.gamesModel.length === this.gamesFiltered.length;
    },
    isGoalkeeper(){
      if (this.headerPlayer) return this.headerPlayer.fieldPositionId === 1; //GK
    },
    tourSteps(){
      return [
        {
          target: `#player-finishing-selector`,
          header: {
            title: this.$t("tours.playerFinishing.step1.title"),
          },
          content: this.$t("tours.playerFinishing.step1.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#player-seasons`,
          header: {
            title: this.$t("tours.playerFinishing.step2.title"),
          },
          content: this.$t("tours.playerFinishing.step2.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#shooting-location`,
          header: {
            title: this.$t("tours.playerFinishing.step3.title"),
          },
          content: this.$t("tours.playerFinishing.step3.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#on-target-section`,
          header: {
            title: this.$t("tours.playerFinishing.step4.title"),
          },
          content: this.$t("tours.playerFinishing.step4.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#shot-filters`,
          header: {
            title: this.$t("tours.playerFinishing.step5.title"),
          },
          content: this.$t("tours.playerFinishing.step5.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#filters`,
          header: {
            title: this.$t("tours.playerFinishing.step6.title"),
          },
          content: this.$t("tours.playerFinishing.step6.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#image-download`,
          header: {
            title: this.$t("tours.playerFinishing.step7.title"),
          },
          content: this.$t("tours.playerFinishing.step7.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#chart`,
          header: {
            title: this.$t("tours.playerFinishing.step8.title"),
          },
          content: this.$t("tours.playerFinishing.step8.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
      ];
    },
    hasPenalties() {
      return _.some(this.shots,(s) => s.strategyId === 9 && this.gamesModel.includes(s.gameId));
    },
    penalties() {
      return this.shots.filter((s) => s.strategyId === 9 && s.periodId !== 5 && this.gamesModel.includes(s.gameId));
    },
    penaltiesShootout() {
      return this.shots.filter((s) => s.strategyId === 9 && s.periodId === 5 && this.gamesModel.includes(s.gameId));
    }
  },
  data() {
    return {
      playerPosition: null,
      size: 0,
      margin: null,
      grounds: [{id: 1, name: this.$t("general.all")},
                {id: 2, name: this.$t("general.home")},
                {id: 3, name: this.$t("general.away")},
                {id: 4, name: this.$t('general.last') + ' ' + this.$t('playerRecruitment.xGames',{0:6})},
                {id: 5, name: this.$t('general.last') + ' ' + this.$t('playerRecruitment.xGames',{0:12})}],
      groundModel: 1,
      lineups: [],
      shots: [],
      filteredShots: [],
      playersWithShots: [],
      xgMap: 0,
      player: null,
      seasonDataSelectedModel: [],
      playerSeasonData: [],
      filteredSeasons: [],
      shotTypes: [
        {id: 16, text: Dictionary[this.$i18n.locale]["finishingMap"]["goal"]},
        {id: 13, text: Dictionary[this.$i18n.locale]["finishingMap"]["missedShot"]},
        {id: 15, text: Dictionary[this.$i18n.locale]["finishingMap"]["savedShot"]},
        {id: 14, text: Dictionary[this.$i18n.locale]["finishingMap"]["shotOnPost"]},
        {id: 60, text: Dictionary[this.$i18n.locale]["finishingMap"]["missedChance"]}
      ],
      shotTypeModel: [13, 14, 15, 16, 60],
      openPlayIds: [22, 23, 123, 215],
      setPieceIds: [26, 24, 25, 124, 160, 279],
      shotStrategies: [
        {id: 'group_open', text: Dictionary[this.$i18n.locale]["finishingMap"]["openPlay"], isGroupHeader: true},
        {id: 22, text: Dictionary[this.$i18n.locale]["finishingMap"]["regularPlay"]},
        {id: 23, text: Dictionary[this.$i18n.locale]["finishingMap"]["fastBreak"]},
        {id: 123, text: Dictionary[this.$i18n.locale]["game"]["gameThreat"]["keeperThrowPlay"]},
        {id: 215, text: Dictionary[this.$i18n.locale]["finishingMap"]["individualPlay"]},
        {id: 'group_set', text: Dictionary[this.$i18n.locale]["finishingMap"]["setPiece"], isGroupHeader: true},
        {id: 26, text: Dictionary[this.$i18n.locale]["finishingMap"]["freeKick"]},
        {id: 24, text: Dictionary[this.$i18n.locale]["finishingMap"]["indirectFreeKick"]},
        {id: 25, text: Dictionary[this.$i18n.locale]["finishingMap"]["fromCorner"]},
        {id: 124, text: Dictionary[this.$i18n.locale]["game"]["gameThreat"]["gkKick"]},
        {id: 160, text: Dictionary[this.$i18n.locale]["finishingMap"]["throwInSetPiece"]},
        {id: 279, text: Dictionary[this.$i18n.locale]["videoHighlights"]["qualifierIds"]["279"]}
      ],
      shotStrategyModel: [22, 23, 215, 24, 25, 26, 160, 123, 124, 279],
      areaModel: [],
      goalAreaModel: ['highLeft', 'highCenter', 'highRight', 'lowLeft', 'lowCenter', 'lowRight', 'outHighLeft',
        'high', 'outHighRight', 'closeHighLeft', 'closeHigh', 'closeHighRight', 'closeLeft', 'closeRight'],
      bodyParts: [
        {id: 15, text: Dictionary[this.$i18n.locale]["finishingMap"]["head"]},
        {id: 72, text: Dictionary[this.$i18n.locale]["finishingMap"]["leftFooted"]},
        {id: 20, text: Dictionary[this.$i18n.locale]["finishingMap"]["rightFooted"]},
        {id: 21, text: Dictionary[this.$i18n.locale]["finishingMap"]["otherBodyPart"]}
      ],
      bodyPartModel: [15, 20, 21, 72],
      minutes: [0, 90],
      checkboxCircles: ['circles'],
      xgOnTarget: false,
      finishingXGOT: false,
      showShotOptions: this.$vuetify.breakpoint.smAndDown ? false : true,
      rangeMinutes: [0,90],
      mediaMode: false,
      mediaModeFields: [
        {type:"text",label:"mediaMode.upperText",key:"upperText"},
        {type:"number",label:"mediaMode.upperTextFontSize",key:"upperTextFontSize"},
        {type:"radio",label:"mediaMode.upperTextFontWeight",key:"upperTextFontWeight",options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"text",label:"mediaMode.lowerText",key:"lowerText"},
        {type:"number",label:"mediaMode.lowerTextFontSize",key:"lowerTextFontSize"},
        {type:"radio",label:"mediaMode.lowerTextFontWeight",key:"lowerTextFontWeight",options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"radio",label:"mediaMode.fontFamily",key:"fontFamily",options:[{value:"NeueMontreal",label:"NeueMontreal"},{value:"NeueMontreal",label:"NeueMontreal"}]},
        {type:"color",label:"mediaMode.borderColor",key:"borderColor"},
        {type:"color",label:"mediaMode.homeFillColor",key:"homeFillColor"},
        {type:"color",label:"mediaMode.homeBorderColor",key:"homeBorderColor"},
        {type:"color",label:"mediaMode.awayFillColor",key:"awayFillColor"},
        {type:"color",label:"mediaMode.awayBorderColor",key:"awayBorderColor"},
        {type:"color",label:"mediaMode.bgColor",key:"bgColor"},
        {type:"color",label:"mediaMode.textColor",key:"textColor"},
        {type:"number",label:"mediaMode.avatarLineLength",key:"lineLength",force:true},
        {type:"number",label:"mediaMode.avatarLineWeight",key:"lineWeight",force:true},
        {type:"number",label:"mediaMode.avatarSize",key:"avatarSize",force:true},
        {type:"image",label:"mediaMode.face",key:"face"},
        {type:"switch",label:"mediaMode.nationalTeam",key:"nationalTeam"},
        {type:"switch",label:"mediaMode.socialMedia",key:"socialMedia"},
        {type:"number",label:"mediaMode.socialMediaFontSize",key:"socialMediaFontSize",force:true},
        {type:"radio",label:"mediaMode.socialMediaFontWeight",key:"socialMediaFontWeight"
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}],force:true},
        {type:"image",label:"mediaMode.sponsor",key:"sponsor",force:true,aspectRatio:16/9,imageRestriction:'none',resizable:true,stencilSize:{width:300,height:300}}
      ],
      chartSize: null,
      avatarSize: null,
      mediaModeFlags: {borderColor:null,bgColor:null,upperText:null,lowerText:null,socialMedia:null, nationalTeam: null,textColor: null,homeFillColor:null,homeBorderColor:null,awayFillColor:null,awayBorderColor:null,face:null},
      mediaModeData: {borderColor:"#3366FF",bgColor:"#ffffff0",upperText:null,lowerText:null,socialMedia:true,nationalTeam: false,textColor:"#000000"
        ,homeFillColor:"#ffffff",homeBorderColor:"#000000",awayFillColor:"#ffffff",awayBorderColor:"#000000",face:{},upperTextFontWeight:"900",lowerTextFontWeight:"400",
        socialMediaFontWeight:"300",socialMediaFontSize:"14",sponsor:{}},
      selectedTab: this.defaultTab,
      loadingExport: false,
      insightSelected: "xg",
      games: [],
      gamesFiltered: [],
      gamesModel: [],
      //Mins played on games selected
      minsPlayed: 0,
      showPenalties: false,
      showShootoutPenalties: false,
      showAllInfoInBoxes: false,
    };
  },
  watch:{
    "$refs.XGMapInstance": function(newValue,oldValue){
      this.updateShots();
    },
    "mediaMode": function(newVal, oldVal) {
      if(!this.stackedView){
        if(!this.mediaMode){
          this.mediaModeData =  {borderColor:"#3366FF",bgColor:"#ffffff0",upperText:null,lowerText:null,socialMedia:true,nationalTeam: false,textColor:"#000000",
          homeFillColor:"#ffffff",homeBorderColor:"#000000",awayFillColor:"#ffffff",awayBorderColor:"#000000",face:{},upperTextFontWeight:"900",lowerTextFontWeight:"400",
          socialMediaFontWeight:"400",socialMediaFontSize:"14",sponsor:{}}
        }
        this.mediaModeData.bgColor = this.mediaMode ? '#ffffff' : '#ffffff0';
        this.mediaModeData.lowerText = this.selectedTab != 'distribution' ? this.$t("playerDetail.finishingMap") : this.$t("finishingMap.finishingTable");
        this.mediaModeData.face.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.player.playerId}.png`;
        this.mediaModeData.face.fallBackSrc = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0_${this.headerPlayer.male === false ? 'f' : 'm'}.png`;
        this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
        this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);
      }
    },
    "mediaModeCfg":function(newVal,oldVal){
      if(_.size(_.keys(newVal))){
        this.onMediaModeDataChange(newVal);
      }
    },
    "mediaModeValue":function(newVal,oldVal){
      if(!_.isEqual(newVal,oldVal)){
        this.mediaMode = newVal
      }
    },
    showFilters() {
      this.$nextTick(() => {
        this.size = this.stackedView ? this.$refs.chart.clientWidth * 0.9 : this.$refs.chart.clientWidth * 0.75; // minus padding normal
        this.onWindowResize(null, true);
      });
    }
  },
  mounted: function() {
    this.mediaMode = this.stackedView ? this.mediaModeValue : (this.currentUser.mediaMode || this.currentUser.clientType === 'Media');
    this.size = this.stackedView ? this.$refs.chart.clientWidth * 0.9 : this.$refs.chart.clientWidth * 0.75; // minus padding normal
    this.margin = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  },
  async created() {
    window.addEventListener("resize", this.onWindowResize);
    this.player = this.headerPlayer;
    this.playerPosition = this.player.fieldPositionId;
    this.games = this.gamesPlayed;
    
    if(this.headerPlayerSeasonData){
      this.playerSeasonData = _.map(this.headerPlayerSeasonData, (h) => { h.compoundId = `${h.seasonId}-${h.teamId}`; h.compoundText = `${h.seasonName}-${h.teamName}`; return h; });
    }else{
      let seasonsData = await PlayerService.getPlayerTeamSeasonData(this.playerId, this.currentUser.clientId);
      this.playerSeasonData = _.map(seasonsData.data,(h) => { h.compoundId = `${h.seasonId}-${h.teamId}`; h.compoundText = `${h.seasonName}-${h.teamName}`; return h; });
    }
    this.playerSeasonData.forEach(s => {
      const league = s.league || (s.label != null ? s : null);
      const year = s.year != null ? s.year : (s.seasonYear != null ? s.seasonYear : null);
      if (league && year != null) {
        s.seasonAlias = getLeagueAndYearName(league, year);
      }
    });
    this.filteredSeasons = this.playerSeasonData.slice(0, 1);

    //Get games of player if games are not received
    if(!this.games){
      await this.loadGamesPlayedOfPlayer();
    }
    //Get shots of player
    let shotsData = await GameService.getXGShotsOfSinglePlayer(this.playerId, this.playerPosition);
    this.shots = shotsData.data.map(s => {
      if (s.strategyId === 9) {
        //Adjust penalty shots' values
        s.xG = [15, 16].includes(s.eventTypeId) ? 0.765 : 0;
        s.xgOnTarget = [15, 16].includes(s.eventTypeId) ? 0.765 : 0;
        s.y = 50;
        s.x = 88.5;
      };
      s.xG = s.xG ? s.xG : 0;      
      s.xGOnTarget = s.xGOnTarget ? s.xGOnTarget : 0;

      //Areas
      let startArea = coordToArea(s.x,s.y,this.currentUserAreas);
      s.startAreaId = _.get(startArea,'id');
      s.startAreaName = _.get(startArea,'name');
      let endArea = coordToArea(s.x_end,s.y_end,this.currentUserAreas);
      s.endAreaId = _.get(endArea,'id');
      s.endAreaName = _.get(endArea,'name');

      return s;
    });

    // Default season : Last Regular season of the player's team
    let defaultSeason = this.playerSeasonData.find(psd => psd.regular && 
                                          psd.teamId === this.player.teamId && 
                                          psd.year === psd.leagueLastYear);

    if(!defaultSeason){
      // If there is no season, take last regular played in other team
      defaultSeason = this.playerSeasonData.find(psd => psd.regular && 
                                        psd.year === psd.leagueLastYear);
    }

    if(!defaultSeason){
      // If there is no season, take first regular from all seasons played
      defaultSeason = this.playerSeasonData.find(psd => psd.regular) || this.playerSeasonData[0];
    }
   
    this.seasonDataSelectedModel = [defaultSeason.compoundId];
    this.filterGames();
    this.updateMins();
    this.updateShots();
    this.mediaModeData.upperText = this.player.name;
    this.mediaModeData.lowerText = this.selectedTab != 'distribution' ? this.$t("playerDetail.finishingMap") : this.$t("finishingMap.finishingTable");
    this.mediaModeData.face.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.player.playerId}.png`;
    this.mediaModeData.face.fallBackSrc = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0_${this.headerPlayer.male === false ? 'f' : 'm'}.png`;
    this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
    this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);

    setTimeout(() => {
      UserService.putLastSearchRendered({id:this.lastSearchId});
    }, 250);

  },
  methods: {
    onWindowResize(e,force = false) {
      setTimeout(() => {
        force = force || (e && e.type === "resize");
        this.updateChart(force);
      },200)
    },
    updateChart(force = false){
      if(this.$refs.chart){
        this.size = this.stackedView ? this.$refs.chart.clientWidth * 0.9 : this.$refs.chart.clientWidth * 0.75;
      }
      if(this.selectedTab === 'distribution'){
        this.xgMap++;
      }
      if(this.$refs.xgChart){
        this.$refs.xgChart.printD3(force)
      }
      if(this.$refs.playerAvatarMediaRef){
        this.$refs.playerAvatarMediaRef.printD3(force)
      }
      if(this.$refs.driblabSocialMediaRef){
        this.$refs.driblabSocialMediaRef.printD3(force)
      }
      this.$forceUpdate();
    },
    toggleGames () {
      this.$nextTick(() => {
        if (this.allGames)
          this.gamesModel = []
        else {
          this.gamesModel = this.gamesFiltered.slice().map(g => g.gameId);
        }
      })
    },
    filterGames(){
      this.filteredSeasons = this.playerSeasonData.filter(s => this.seasonDataSelectedModel.includes(s.compoundId));
      let teamIds = this.filteredSeasons.map(s => s.teamId);
      let seasonIds = this.filteredSeasons.map(s => s.seasonId);
      let gamesOfSeasonAndTeam = this.games.filter(s => teamIds.includes(s.teamId) && seasonIds.includes(s.seasonId));
      switch (this.groundModel) {
        //All
        case 1:
          this.gamesFiltered = gamesOfSeasonAndTeam;
          break;
        //Home
        case 2:
          this.gamesFiltered = gamesOfSeasonAndTeam.filter(g => teamIds.includes(g.homeTeamId));
          break;
        //Away
        case 3:
          this.gamesFiltered = gamesOfSeasonAndTeam.filter(g => teamIds.includes(g.awayTeamId));
          break;
        case 4:
        case 5:
          this.gamesFiltered = gamesOfSeasonAndTeam.slice(0, this.groundModel === 4 ? 6 : 12);
          break;
        default:
          this.gamesFiltered = gamesOfSeasonAndTeam;
      }

      this.gamesModel = this.gamesFiltered.map(g => g.gameId);
    },
    onSelectChange(){
      this.filterGames();
      this.updateShots();
    },
    async loadGamesPlayedOfPlayer() {
      let gamesResponse = await PlayerService.getGamesPlayedOfPlayer(this.playerId);
      this.games = gamesResponse.data;
      //Create game name
      this.games.forEach(g => {
        g.name = `${g.homeTeamName} ${g.homeTeamScore}:${g.awayTeamScore} ${g.awayTeamName}`;
      });

    },
    shotsInArea(shots) {
      return shots
        .filter(s => this.areaModel.includes(s.startAreaId) || _.isEmpty(this.areaModel))
    },
    shotsInGoalArea(shots) {
      return shots
        .filter(s => this.goalAreaModel.includes('highLeft') || !(s.z_mouth >= 20 && s.z_mouth <= 42 && s.y1 >= 51.8 && s.y1 < 55.8))
        .filter(s => this.goalAreaModel.includes('highCenter') || !(s.z_mouth >= 20 && s.z_mouth <= 42 && s.y1 >= 48.2 && s.y1 < 51.8))
        .filter(s => this.goalAreaModel.includes('highRight') || !(s.z_mouth >= 20 && s.z_mouth <= 42 && s.y1 >= 44.2 && s.y1 < 48.2))
        .filter(s => this.goalAreaModel.includes('lowLeft') || !(s.z_mouth >= 0 && s.z_mouth <= 20 && s.y1 >= 51.8 && s.y1 < 55.8))
        .filter(s => this.goalAreaModel.includes('lowCenter') || !(s.z_mouth >= 0 && s.z_mouth <= 20 && s.y1 >= 48.2 && s.y1 < 51.8))
        .filter(s => this.goalAreaModel.includes('lowRight') || !(s.z_mouth >= 0 && s.z_mouth <= 20 && s.y1 >= 44.2 && s.y1 < 48.2))
        .filter(s => this.goalAreaModel.includes('outHighLeft') || !(s.z_mouth >= 60 && s.z_mouth <= 92.5 && s.y1 >= 55.8 && s.y1 < 61))
        .filter(s => this.goalAreaModel.includes('high') || !(s.z_mouth >= 60 && s.z_mouth <= 92.5 && s.y1 >= 44.2 && s.y1 < 55.8))
        .filter(s => this.goalAreaModel.includes('outHighRight') || !(s.z_mouth >= 60 && s.z_mouth <= 92.5 && s.y1 >= 39 && s.y1 < 44.2))
        .filter(s => this.goalAreaModel.includes('closeHighLeft') || !(s.z_mouth >= 40 && s.z_mouth <= 60 && s.y1 >= 55.8 && s.y1 < 61))
        .filter(s => this.goalAreaModel.includes('closeHigh') || !(s.z_mouth >= 40 && s.z_mouth <= 60 && s.y1 >= 44.2 && s.y1 < 55.8))
        .filter(s => this.goalAreaModel.includes('closeHighRight') || !(s.z_mouth >= 40 && s.z_mouth <= 60 && s.y1 >= 39 && s.y1 < 44.2))
        .filter(s => this.goalAreaModel.includes('closeLeft') || !(s.z_mouth >= 0 && s.z_mouth <= 40 && s.y1 >= 55.8 && s.y1 < 61))
        .filter(s => this.goalAreaModel.includes('closeRight') || !(s.z_mouth >= 0 && s.z_mouth <= 40 && s.y1 >= 39 && s.y1 < 44.2))
    },
    updateShots() {
      this.filteredSeasons = this.playerSeasonData
        .filter(s => this.seasonDataSelectedModel.includes(s.compoundId));
      this.filteredShots = this.filterShots();

      setTimeout(() => { this.updateChart(true); },100);
    },
    toggleShotStrategies () {
      this.$nextTick(() => {
        if (this.allShotStrategies) {
          this.shotStrategyModel = []
        } else {
          this.shotStrategyModel = this.shotStrategies.filter(s => !s.isGroupHeader).map(s => s.id)
        }
        this.updateShots();
      })
    },
    onStrategyInput () {
      const hasGroupOpen = this.shotStrategyModel.includes('group_open');
      const hasGroupSet = this.shotStrategyModel.includes('group_set');
      if (hasGroupOpen || hasGroupSet) {
        let newModel = this.shotStrategyModel.filter(id => id !== 'group_open' && id !== 'group_set');
        if (hasGroupOpen) {
          const allSelected = this.openPlayIds.every(id => newModel.includes(id));
          if (allSelected) {
            newModel = newModel.filter(id => !this.openPlayIds.includes(id));
          } else {
            this.openPlayIds.forEach(id => { if (!newModel.includes(id)) newModel.push(id); });
          }
        }
        if (hasGroupSet) {
          const allSelected = this.setPieceIds.every(id => newModel.includes(id));
          if (allSelected) {
            newModel = newModel.filter(id => !this.setPieceIds.includes(id));
          } else {
            this.setPieceIds.forEach(id => { if (!newModel.includes(id)) newModel.push(id); });
          }
        }
        this.shotStrategyModel = newModel;
      }
      this.updateShots();
    },
    isStrategyGroupSelected (groupId) {
      const ids = groupId === 'group_open' ? this.openPlayIds : this.setPieceIds;
      return ids.every(id => this.shotStrategyModel.includes(id));
    },
    toggleShotTypes () {
      this.$nextTick(() => {
        if (this.allShotTypes) {
          this.shotTypeModel = [];
        } else {
          this.shotTypeModel = this.shotTypesFiltered.map(p => p.id);
        }
        this.updateShots();
      })
    },
    toggleBodyPart () {
      this.$nextTick(() => {
        if (this.allBodyParts) {
          this.bodyPartModel = []
        } else {
          this.bodyPartModel = this.bodyParts.map(function(p) { return p.id; })
        }
        this.updateShots();
      })
    },
    async prepareSvgForMedia(){
      let parent = document.createElementNS('http://www.w3.org/2000/svg','svg');
      let heightAccum = 0;
      let yOffset = 120;
      parent.style.background = this.mediaModeData.bgColor;


      //COPY HEADER
      copyAndAppendElement(parent,document.querySelector(`#playerAvatarMedia${this.playerId}-${this.chartId}SVG`),100,0)
      heightAccum += this.selectedTab === 'topView' ? this.avatarSize.height : this.avatarSize.height * 1.25;

      if(this.selectedTab != 'distribution'){
        copyAndAppendElement(parent,document.querySelector(`#pitchXG${this.playerId}-${this.chartId}SVG`),100,heightAccum)
        heightAccum += this.chartSize.height;
      }else{
        let canvas = await html2canvas(document.querySelector(`#finishingTable${this.playerId}-${this.chartId}Table`))
        let imgData = canvas.toDataURL("image/png");
        let img = d3.select(parent).append('image',imgData).attr("href",imgData).attr("width",this.size * 1.25).attr("x",100).attr("y",heightAccum);
        heightAccum += Number(canvas.style.height.replace("px",""));

        let font = await loadFonts();
        copyAndAppendElement(parent,font.node(),0,0);
      }

      if(this.mediaModeData.socialMedia && !this.stackedView){
        copyAndAppendElement(parent,document.querySelector(`#driblabSocialMedia${this.playerId}-${this.chartId}SVG`),100,heightAccum)
        heightAccum += 50;
      }

      let parentWidth = this.stackedView ? this.size : this.chartSize.width;
      parentWidth = this.selectedTab === 'topView' ? parentWidth : parentWidth * 1.25
      parent.setAttribute("width",parentWidth);
      parent.setAttribute("height",heightAccum);
      return parent;
    },
    async saveAsPNG() {
      let name = this.selectedTab != 'distribution' ? 'XGMap' : 'Finishing Table';
      if(this.mediaMode){
        let svg = await this.prepareSvgForMedia();
        downloadPng(svg, `Driblab_${name.replace(' ','_')}_` + this.player.name.replace(' ','_') + ".png");
      }else{
        let svg
        if(this.selectedTab != 'distribution'){
          svg = d3.select(`#pitchXG${this.playerId}-${this.chartId}`)
          .select("svg").node()
        }else{
          let parent = document.createElementNS('http://www.w3.org/2000/svg','svg');
          let canvas = await html2canvas(document.querySelector(`#finishingTable${this.playerId}-${this.chartId}Table`))
          let imgData = canvas.toDataURL("image/png");
          let img = d3.select(parent).append('image',imgData).attr("href",imgData).attr("width",this.size * 1.25).attr("x",0).attr("y",0);
          parent.setAttribute("width",Number(canvas.style.width.replace("px","")));
          parent.setAttribute("height",Number(canvas.style.height.replace("px","")));
          svg = parent;
        }
        downloadPng(svg, `Driblab_${name.replace(' ','_')}_` + this.player.name.replace(' ','_') + ".png");
      }
    },
    async saveAsSVG() {
      let name = this.selectedTab != 'distribution' ? 'XGMap' : 'Finishing Table';
      if(this.mediaMode){
        let svg = await this.prepareSvgForMedia();
        exportSvg(svg, `Driblab ${name} - ` + this.player.name, true, this.mediaModeData.bgColor);
      }else{
        let svg;
        if(this.selectedTab != 'distribution'){
          svg = d3.select(`#pitchXG${this.playerId}-${this.chartId}`)
          .select("svg").node()
        }else{
          let parent = document.createElementNS('http://www.w3.org/2000/svg','svg');
          let canvas = await html2canvas(document.querySelector(`#finishingTable${this.playerId}-${this.chartId}Table`))
          let imgData = canvas.toDataURL("image/png");
          let img = d3.select(parent).append('image',imgData).attr("href",imgData).attr("width",this.size * 1.25).attr("x",0).attr("y",0);
          parent.setAttribute("width",Number(canvas.style.width.replace("px","")));
          parent.setAttribute("height",Number(canvas.style.height.replace("px","")));
          svg = parent;
        }
        exportSvg(svg, `Driblab ${name} - ` + this.player.name);
      }
    },
    async getElementToExport(){
      if(this.mediaMode){
        return await this.prepareSvgForMedia()
      }else{
        let svg;
        if(this.selectedTab != 'distribution'){
          svg = d3.select(`#pitchXG${this.playerId}-${this.chartId}`)
          .select("svg").node()
        }else{
          let parent = document.createElementNS('http://www.w3.org/2000/svg','svg');
          let canvas = await html2canvas(document.querySelector(`#finishingTable${this.playerId}-${this.chartId}Table`))
          let imgData = canvas.toDataURL("image/png");
          let img = d3.select(parent).append('image',imgData).attr("href",imgData).attr("width",this.size * 1.25).attr("x",0).attr("y",0);
          parent.setAttribute("width",Number(canvas.style.width.replace("px","")));
          parent.setAttribute("height",Number(canvas.style.height.replace("px","")));
          svg = parent;
        }
        return svg
      }
    },
    updateMins(){
      this.rangeMinutes = [0,_.chain(this.shots).map(s => s.min).max().value()];
      this.rangeMinutes[1] = this.rangeMinutes[1] < 90 ? 90 : this.rangeMinutes[1];
      this.minutes = this.rangeMinutes;
      this.$forceUpdate();
    },
    filterShots(includeMins = true){
      const minutesMaxFilter = this.minutes[1];
      let filtered;

      //If gameId > 0, then filter by game to show just xG of that game
      if(this.gameId > 0){
        filtered = this.shots.filter(s => s.gameId == this.gameId);
      }else{
        if(this.gameIds.length){
          filtered = this.shots.filter(s => this.gameIds.includes(s.gameId));
        }else{
          filtered = this.shots
          .filter(s =>  this.gamesModel.includes(s.gameId))
          .filter(s => this.shotTypeModel.includes(s.eventTypeId))
          .filter(s => this.shotStrategyModel.includes(s.strategyId))
          .filter(s => this.bodyPartModel.includes(s.bodyPartId))
        }
      }

      if (this.playerPosition === 1) {
        filtered = filtered.filter(s => !s.blockedByOutfielderPlayer);
      }

      if(includeMins){
        filtered = filtered.filter(s => s.min >= this.minutes[0] && s.min <= minutesMaxFilter);
      }

      if(this.selectedTab === 'topView' || this.selectedTab === 'distribution'){
        filtered = this.shotsInArea(filtered);
      }else if(this.selectedTab === 'frontView'){
        filtered = this.shotsInGoalArea(filtered);
      }

      //Include penalties only when the respective filters are enabled
      if (this.showPenalties) {
        filtered = filtered.concat(this.penalties.filter(p => this.gamesModel.includes(p.gameId)));
      }
      if (this.showShootoutPenalties) {
        filtered = filtered.concat(this.penaltiesShootout.filter(p => this.gamesModel.includes(p.gameId)));
      }

      //Count total minutes played of games selected
      this.minsPlayed = this.gamesFiltered.filter(g => this.gamesModel.includes(g.gameId)).reduce((acc, game) => (acc + game.minsPlayed), 0);
      return filtered;
    },
    onChartSizeChange(size){
      this.chartSize = size;
      this.avatarSize = {
        width: size.width,
        height: size.height / 4.75
      }
    },
    onLoaded(event){
      //Emit when is loaded
      this.$emit("loaded", event);
    },
    onMediaModeDataChange(event){
      this.mediaModeData = event;
      setTimeout(() => { this.updateChart(this.mediaModeData.force); }, 666);
    },
    onTabChange(tab){
      if(tab === 'distribution'){
        this.mediaModeData.lowerText = this.$t("finishingMap.finishingTable");
        this.seasonDataSelectedModel =  _.chain(this.playerSeasonData).filter(s => s.regular).map(s => s.compoundId).value();
      }else{
        this.mediaModeData.lowerText = this.$t("playerDetail.finishingMap");
      }

      this.onSelectChange();
      this.updateShots();
      this.postSearch();
    },
    async postSearch(){
      const authorized = true;
      const category ='player';
      let urlId = this.playerId;
      //maps means FinishinMap, don't rename because ToolEnum url
      const tool = 'maps';
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const browser = navigator.userAgent;
      const metaInfo = JSON.stringify({tab:this.selectedTab});
      let searchResponse = await UserService.postUserSearch(category, tool, urlId, authorized, this.$route.path, timeZone, browser,metaInfo);
      UserService.putLastSearchRendered({category,tool,id:searchResponse.data});
    },
    async onGenerateIFrameClick(){
      this.loadingExport = true;
      let elToExport = await this.getElementToExport();
      let key = v4();
      key = `${key}.json`;
      let heightOffsetMediaMode = this.selectedTab === 'frontView' ? 0.695 : 0.94;
      let heightOffset = this.selectedTab === 'frontView' ? 1 : 1;
      let chartObject = {
        awsKey:key,
        tool: 'finishing-map',
        category: 'player',
        componentId: this.playerId,
        width: elToExport.getAttribute("width"),
        height: this.mediaMode && this.selectedTab === 'topView' ? elToExport.getAttribute("width") * heightOffsetMediaMode : elToExport.getAttribute("height") * heightOffset
      }
      let postResponse = await UserChartService.postChart(chartObject)
      let chartEntity = postResponse.data;

      this.$refs.chartExportLinksModalRef.open(chartEntity);
      this.loadingExport = false;

      let urlResponse = await UserChartService.getUploadURL(chartEntity.id,key);
      let uploadUrl = urlResponse.data;
      const gameIdsForEmbed = this.gameIds.length ? this.gameIds : (this.gamesModel || []).length ? this.gamesModel : [...new Set((this.filteredShots || []).map(s => s.gameId))];
      var jsonse = JSON.stringify({
        size: Number(chartEntity.width),
        height: Number(chartEntity.height),
        shots: this.filteredShots,
        circlesAndBoxes: this.checkboxCircles,
        playerPosition:this.playerPosition,
        playerSeasonData:this.filteredSeasons,
        player:this.player,
        language:this.currentUserLanguage,
        mediaModeData: this.mediaModeData,
        mediaMode: this.mediaMode,
        selectedTab: this.selectedTab,
        playerAvatarKey: 0,
        key: this.xgMap,
        socialMediaKey: 2,
        id: `${this.player.playerId}-${this.chartId}`,
        teamId: this.player && this.player.teamId,
        insightSelected: this.insightSelected,
        gameIds: gameIdsForEmbed,
        minsPlayed: this.minsPlayed,
        gameName: gameIdsForEmbed.length === 1 ? this.gameName : '',
        filterMinutesRange: this.filterMinutesText,
        filterShotTypeText: this.filterShotTypeText,
        filterShotStrategyText: this.filterShotStrategyText,
        filterBodyPartText: this.filterBodyPartText,
        chartType:"finishing-map"
      });

      var blob = new Blob([jsonse], {type: "application/json"});
      // let blob = exportSvgToFile(elToExport);
      let uploadResponse = await DocumentService.upload(uploadUrl,blob);
      this.postSearchChart(chartEntity);
    },
    async postSearchChart(chart){
      const authorized = true;
      let metaInfo = null;
      let category = 'player';
      let urlId = this.playerId;

      metaInfo = JSON.stringify({
        link: `${API_URL}${chart.id}/key/${chart.awsKey}/compId/${chart.componentId}/catId/${chart.categoryId}/tId/${chart.toolId}`
      });
      const tool = 'embed';
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const browser = navigator.userAgent;
      let searchResponse = await UserService.postUserSearch(category, tool, urlId, authorized, this.$route.path, timeZone, browser, metaInfo);
      UserService.putLastSearchRendered({category,tool,id:searchResponse.data})
    },
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
    onInsightChange(){
        this.xgMap++;
    },
    onSelectAreaClick(){
      this.$refs.areaSelectorModalRef.open();
    },
    onAreaSelectorConfirm(event){
      if (event && event.ids && event.ids.length > 0) this.areaModel = event.ids;
      else this.areaModel = [];
      this.updateShots();
    },
    onSelectGoalAreaClick(){
      this.$refs.goalAreaSelectorModalRef.open();
    },
    onGoalAreaSelectorConfirm(event){
      if (event && event.codes && event.codes.length > 0) this.goalAreaModel = event.codes;
      else this.goalAreaModel = [];
      this.updateShots();
    }
  },
  destroyed() {
    this.shots = null;
    d3.selectAll('.tooltip').remove();
    window.removeEventListener("resize", this.onWindowResize);
  }
};
</script>

<style>

  #player-finishing-selector.v-input--radio-group {
    align-items: center;
  }
  #player-finishing-selector .v-radio {
    align-items: center;
  }
  #player-finishing-selector .v-input--selection-controls__input {
    margin-right: 8px;
  }
  #player-finishing-selector .v-label {
    align-items: center;
    display: inline-flex;
  }

  body > div.tooltip {
    font-family: 'NeueMontreal';
    pointer-events: none;
    position: absolute;
    background: none repeat scroll 0 0 #ffffff;
    padding: 5px 10px 5px 10px;
    border-radius: 4px;
    text-align: center;
    display: none;
    line-height: 1.5;
    color: #081F2C;
    box-shadow: 0px 3px 9px rgba(0, 0, 0, .15);
  }

  body > div.tooltip:after {
    box-sizing: border-box;
    display: block;
    width: 100%;
    line-height: 2.8;
    color: #000000;
    content: "\25BC";
    text-align: center;
  }
  v-messages {
    height: 6px;
  }

</style>



// WEBPACK FOOTER //
// src/views/player/PlayerFinishingMap.vue